import { Controller } from "@hotwired/stimulus"
import { SIDE_FILTER_SELECTOR } from "@/lib/Listing/MobileFilterHelpers.js"
import { applyFilterState, FILTERS_HYDRATED_EVENT } from "@/lib/Listing/FilterState.js"

export default class extends Controller {
  static values = { state: Object }

  connect() {
    document.querySelectorAll(SIDE_FILTER_SELECTOR).forEach((form) => applyFilterState(form, this.stateValue))
    document.dispatchEvent(new CustomEvent(FILTERS_HYDRATED_EVENT))
  }
}
